/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import {
  ProductResponse,
  ProductServer, ProductServerDuration,
  ProductServerLocation,
  ProductState,
} from './types';
import { MutationRequestStatus, RootState } from '../types';
import { getDefaultErrorState, getDefaultLoadingState } from '@a/store/utils';

export const getters: GetterTree<ProductState, RootState> = {
  product(state): ProductResponse {
    return state.orderProduct.data;
  },
  locations(state): Array<ProductServerLocation> | undefined {
    return !state.orderProduct.data
      ? undefined
      : state.orderProduct.data.locations;
  },
  game(state): ProductServer {
    return state.orderProduct.data.server;
  },

  isOrderProductLoading: (state) => state.orderProduct.status === getDefaultLoadingState().status,
  isOrderProductFailure: (state) => state.orderProduct.status === getDefaultErrorState().status,
  isOrderProductAvailable: (state) => state.orderProduct.status === MutationRequestStatus.SUCCESS,
};
